module.exports = __webpack_public_path__ + "img/defaultavatar.f53af6b0.png";